import { createUseStyles } from 'react-jss'
import Gallery from '@/components/Gallery'
import style from './style'

const useStyles = createUseStyles(style)

function GallerySection({ pretitle, title, gallery }) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Gallery
        pretit={pretitle}
        title={title}
        items={gallery.map((item) => ({
          id: item.id,
          img: item?.sizes?.medium_large?.url || item?.url,
          title: item?.title,
          alt: item?.alt,
          ratio: item.width > item.height ? 'horizontal' : 'vertical',
        }))}
      />
    </div>
  )
}

export default GallerySection
